import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { ChargingActionsService } from 'src/app/services/charging-actions.service';

import Swal from 'sweetalert2';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Reason } from 'src/app/models/charge-point-actions/reason-for-manual-start';

@Component({
  selector: 'app-reset-security-profile',
  templateUrl: './reset-security-profile.component.html',
  styleUrls: ['./reset-security-profile.component.scss']
})
export class ResetSecurityProfileComponent implements OnInit {

  constructor(private actionService: ChargingActionsService, private dialogRef: DynamicDialogRef) { }

  resetSecurityProfileModel: Reason;

  resetSecurityProfileForm: UntypedFormGroup;
  ngOnInit(): void {
    this.resetSecurityProfileForm = new UntypedFormGroup({
      reason: new UntypedFormControl('', Validators.required)
    });
  }

  onSubmit(): void {
    if (this.resetSecurityProfileForm.valid) {
      this.resetSecurityProfileModel = this.resetSecurityProfileForm.value;
      // this.actionService.reset(any).subscribe(
      //   (res) => {
      //     if (res.returnStatus) {
      //       Swal.fire({
      //         position: 'top-end',
      //         icon: 'success',
      //         title: 'Success',
      //         text: res.message,
      //         showConfirmButton: false,
      //         timer: 4000
      //       });
      //     }
      //     this.dialogRef.close();
      //   },
      //   (error) => {
      //     console.log(error);
      //     this.dialogRef.close();
      //   }
      // );
    }
    else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error',
        text: 'Please fill required details',
        showConfirmButton: true,
        confirmButtonText: 'OK'
      });
    }
  }

  onReset(): void {
    this.resetSecurityProfileForm.reset();
    this.dialogRef.close();
  }

}
